import {EnsNotification} from '../../../store/features/ens/types';

export const getDispatchEventLabel = (
    user: string,
    notification: Pick<EnsNotification, 'channel' | 'mobilePushSent'>,
): string => {
    if (notification.channel !== 'PUSH') return `${user}: sent`;
    return notification.mobilePushSent
        ? `${user}: sent to mobile and available on web`
        : `${user}: available on web only`;
};
